import { z } from "zod";

/**
 * One reason ops gave for a verdict: a code from the card's own reason list (e.g. why a referral was
 * forwarded as ineligible), with ops' free text in `detail` where the reason takes it, such as
 * "Other". The same `{ code, detail }` shape steps use for their own reasons, so the two compare by
 * code. The list belongs to the customer's card, so the server action that offers it checks the
 * codes; the public verdict input carries none.
 */
export const verdictReasonSchema = z
  .object({
    code: z.string().trim().min(1).max(100),
    detail: z.string().trim().min(1).max(2000).optional(),
  })
  .strict();

export type VerdictReason = z.infer<typeof verdictReasonSchema>;

export const verdictReasonsSchema = z.array(verdictReasonSchema).max(20);
